<template>
  <div class="start-page">
    <div id="tipping" class="loading-parent">
      <div class="userinfo">
        <div class="hi">{{ $t('start.hi') || 'Hi' }}, {{ userInfo ? (userInfo.username || userInfo.id) : '' }}</div>
        <!-- 资金概览卡片 -->
        <div class="stats-card">
          <div class="commission-item">
            <div class="com-title">{{ $t('start.today_income') || "Income" }}</div>
            <div class="money">{{ $money(userInfo ? (userInfo.today_total_commission || 0) : 0) }}</div>
          </div>
          <div class="stats-divider"></div>
          <div class="commission-item">
            <div class="com-title">{{ $t('start.balance') || 'Balance' }}</div>
            <div class="money">{{ $money(userInfo ? (userInfo.money || 0) : '0.00') }}</div>
          </div>
        </div>
        <div class="row row-sb">
          <div class="menu-order" @click="goFundRecord">
            <img src="/img/start/order-list.c7220579.png" alt="" class="menu-order_img">
            <div class="info">{{ $t('start.orders') || 'Orders' }}</div>
          </div>
          <div class="menu-order" @click="openOrderModal">
            <img src="/img/start/order.68071053.png" alt="" class="menu-order_img">
            <div class="info info-center">
              <div class="grab-center">
                <span class="info-title">{{ $t('start.start_grabbing') || 'Start Grabbing Orders' }}</span>
                <!-- 标题正下方居中：(已完成X/总数量Y)，所有VIP等级均显示 -->
                <div class="order-progress">({{ $t('start.completed') || '已完成' }}{{ todayCompleted }}/{{ $t('start.total_count') || '总数量' }}{{ vipOrderLimit }})</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="main-body">
        <div class="vip-info" @click="goMembership">
          <span>VIP</span>
          <div class="row column-c vip-right">
            <span>{{ $t('start.current_level') || 'current level' }}:</span>
            <span>{{ userInfo ? (userInfo.vip || 'VIP 0') : 'VIP 0' }}</span>
            <img src="/img/VIP.png">
            <van-icon name="arrow" />
          </div>
        </div>
        
        <div class="menu-list">
          <div class="menu-item" @click="goWithdraw">
            <div class="row column-c">
              <img src="/img/start/withdraw.0f516beb.png" alt="">
              <span>{{ $t('start.withdraw_money') || 'Withdraw Money' }}</span>
            </div>
            <van-icon name="arrow" />
          </div>
          <div class="menu-item" @click="goService">
            <div class="row column-c">
              <img src="/img/start/concat.f67c0cbc.png" alt="">
              <span>{{ $t('start.customer_service') || 'Customer Service' }}</span>
            </div>
            <van-icon name="arrow" />
          </div>
          <div class="menu-item" @click="goRecharge">
            <div class="row column-c">
              <img src="/img/start/recharge-tipping.24a94cf1.png" alt="">
              <span>{{ $t('start.recharge') || 'Recharge' }}</span>
            </div>
            <van-icon name="arrow" />
          </div>
          <div class="menu-item" @click="$router.push('/lottery')">
            <div class="row column-c">
              <img src="/img/start/turntable.ae50c34f.png" alt="">
              <span>{{ $t('start.lucky_mission') || 'Lucky Mission' }}</span>
            </div>
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
    </div>

    <!-- 成功提示消息 -->
    <div v-if="showSuccess" class="message-toast success-toast">
      <div class="toast-icon">✅</div>
      <span>{{ successMessage }}</span>
    </div>

    <!-- 错误提示消息 -->
    <div v-if="showError" class="message-toast error-toast">
      <div class="toast-icon">❌</div>
      <span>{{ errorMessage }}</span>
    </div>

    <!-- 订单弹窗 -->
    <div v-if="showOrderModal" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>{{ $t('start.submit_all_orders') }}</h3>
          <button class="close-btn" @click="closeModal">&times;</button>
        </div>

        <div class="modal-body">
          <!-- 打针订单提示：幸运订单话术（所有VIP等级统一文案） -->
          <!-- 打针弹窗提示：幸运订单话术 + 充值金额单行（同色同样式，所有等级统一） -->
          <div v-if="currentOrder && currentOrder.order_type === 'card_order'" class="dazhen-recharge-notice">
            {{ $t('start.dazhen_notice_1') }}
            <div class="dazhen-recharge-amount">{{ $t('start.recharge_formula') }}={{ $money(formatMoney(rechargeNeeded)) }}</div>
          </div>

          <div v-if="loading" class="loading-order">
            <div class="loading-icon">⏳</div>
            <span>{{ $t('start.loading_orders') }}</span>
          </div>

          <div v-else-if="currentOrder" class="order-info">
            <div class="order-time">
              <span class="time-label">{{ $t('start.time_to_rush') }}</span>
              <span class="time-value">{{ getCurrentTime() }}</span>
            </div>
            <div class="order-number">
              <span class="number-label">{{ $t('start.order_number') }}</span>
              <span class="number-value">{{ currentOrder.order_id || currentOrder.id }}</span>
            </div>
            <div class="goods-card">
              <div v-if="currentOrder.goods_pic" class="goods-image-section">
                <img
                  :src="currentOrder.goods_pic"
                  :alt="currentOrder.goods_name"
                  class="goods-image"
                  @error="handleImageError"
                />
              </div>
              <div class="goods-info-section">
                <div class="goods-name">{{ currentOrder.goods_info }}</div>
                <div class="goods-brand">Kanta Lekap</div>
              </div>
            </div>
            <div class="amount-summary">
              <div class="amount-row">
                <span class="amount-label">{{ $t('start.total_order') }}</span>
                <span class="amount-value">{{ $money(currentOrder.goods_price) }}</span>
              </div>
              <div class="amount-row">
                <span class="amount-label">{{ $t('start.commission') }}</span>
                <span class="commission-value">{{ $money(formatMoney(currentOrder.commission)) }}</span>
              </div>
            </div>
          </div>

          <div v-else class="no-order">
            <div class="no-order-icon">⚠️</div>
            <span>{{ $t('start.no_available_orders') }}</span>
          </div>
        </div>

        <!-- 弹窗底部按钮区：所有VIP等级统一
             常规订单：左"取消" + 右"确认付款"
             打针幸运订单(card_order)：左"取消" + 中"去充值" + 右"确认付款" 三按钮并排；
             余额/充值不足时后端 placeOrder 拒绝付款并弹出提示，按钮功能完整有效 -->
        <div class="modal-footer">
          <button class="cancel-btn" @click="closeModal">{{ $t('start.cancel') }}</button>
          <!-- 打针订单：中间"去充值"按钮，跳转充值页 -->
          <button
            v-if="currentOrder && currentOrder.order_type === 'card_order'"
            class="recharge-btn"
            @click="goRecharge"
          >
            {{ $t('start.go_recharge') }}
          </button>
          <button
            v-if="currentOrder"
            class="place-order-btn"
            @click="placeOrder"
            :disabled="orderLoading"
          >
            <span v-if="orderLoading">{{ $t('start.payment_processing') }}</span>
            <span v-else>{{ $t('start.confirm_payment') }}</span>
          </button>
          <button v-else class="refresh-btn" @click="goToOrderHistory">
            {{ $t('start.go_to_view') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http/index'

export default {
  name: 'StartPage',

  data() {
    return {
      showOrderModal: false,
      currentOrder: null,
      loading: false,
      orderLoading: false,
      successMessage: '',
      errorMessage: '',
      showSuccess: false,
      showError: false,
      userInfo: null,
      userLoading: false,
    }
  },

  created() {
    this.getUserInfo()
  },

  computed: {
    // 今日已完成订单数（后端 user_info 返回）
    todayCompleted() {
      const d = this.userInfo && this.userInfo.daily_order_limit;
      if (d && d.today_completed !== undefined && d.today_completed !== null) return d.today_completed;
      return (this.userInfo && this.userInfo.today_orders_count) || 0;
    },
    // 当前 VIP 等级对应的任务订单数
    vipOrderLimit() {
      const d = this.userInfo && this.userInfo.daily_order_limit;
      return (d && d.daily_limit) || 0;
    },
    // 打针弹窗：充值金额 = 订单总额 - 会员账号的余额（不足0时显示0）
    rechargeNeeded() {
      if (!this.currentOrder) return 0;
      const total = parseFloat(this.currentOrder.goods_price) || 0;
      const balance = this.userInfo ? (parseFloat(this.userInfo.money) || 0) : 0;
      return Math.max(0, total - balance);
    },
  },

  methods: {
    // 金额格式化：保留两位小数，避免后端浮点计算出现长尾小数
    formatMoney(v) {
      const n = Number(v);
      return isNaN(n) ? '0.00' : n.toFixed(2);
    },
    async getUserInfo() {
      try {
        this.userLoading = true
        const result = await http({ method: 'get', url: 'user_info' })
        if (result && result.code === 200) {
          this.userInfo = result.data
        } else {
          console.error('获取用户信息失败:', result.msg)
        }
      } catch (error) {
        console.error('获取用户信息出错:', error)
      } finally {
        this.userLoading = false
      }
    },

    openOrderModal() {
      if (this.userLoading) {
        this.$toast(this.$t('start.loading_user_info'))
        return
      }
      // 已取消今日订单上限限制：任何VIP等级均可随时开始抢购订单任务
      this.showOrderModal = true
      this.getUserOrders()
    },

    closeModal() {
      this.showOrderModal = false
      this.getUserInfo()
    },

    goToOrderHistory() {
      this.$router.push('/GameRecord')
    },

    // ── 导航 ──────────────────────────────────────────
    goBack()       { this.$router.go(-1)                 },
    goWithdraw()   { this.$router.push('/withdraw')      },
    goService()    { this.$router.push('/ServiceOnline') },
    goRecharge()   { this.$router.push('/recharge')      },
    goFundRecord() { this.$router.push('/GameRecord')    },
    goMembership() { this.$router.push('/membership')    },

    async getUserOrders() {
      try {
        this.loading = true
        const result = await http({ method: 'get', url: 'getUserOrders' })
        if (result && result.code === 200) {
          if (result.data.orders && result.data.orders.length > 0) {
            this.currentOrder = result.data.orders[0]
          } else {
            this.showErrorMessage(this.$t('start.insufficient_balance'))
            this.closeModal()
            this.currentOrder = null
          }
        } else if (result && result.code === 402) {
          // 存在未付款订单："未完成订单"提示条已按需求删除，
          // 不再弹提示，弹窗显示"去查看"引导用户前往订单记录处理
          this.currentOrder = null
        } else if (result && result.code === 401) {
          this.showErrorMessage(result.msg || this.$t('start.get_order_failed'))
          this.closeModal()
          this.currentOrder = null
        } else {
          this.currentOrder = null
        }
      } catch (error) {
        console.error('获取订单出错:', error)
        this.currentOrder = null
      } finally {
        this.loading = false
      }
    },

    async placeOrder() {
      if (!this.currentOrder) {
        alert(this.$t('start.no_available_order'))
        return
      }
      try {
        this.orderLoading = true
        const result = await http({
          method: 'post',
          url: 'placeOrder',
          data: { order_id: this.currentOrder.order_id || this.currentOrder.id, quantity: 1 },
        })
        if (result && result.code === 200) {
          this.showSuccessMessage(this.$t('start.payment_success'))
          this.getUserInfo()
          setTimeout(() => { this.closeModal() }, 1500)
        } else {
          // 后端返回明确提示时直接展示（如打针充值门槛提示），否则回退付款失败前缀
          this.showErrorMessage(result.msg || (this.$t('start.payment_failed')))
        }
      } catch (error) {
        console.error('付款出错:', error)
        this.showErrorMessage(this.$t('start.payment_failed_retry'))
      } finally {
        this.orderLoading = false
      }
    },

    handleImageError(event) {
      event.target.style.display = 'none'
    },

    getCurrentTime() {
      const now = new Date()
      const p   = v => String(v).padStart(2, '0')
      return `${now.getFullYear()}-${p(now.getMonth()+1)}-${p(now.getDate())} ${p(now.getHours())}:${p(now.getMinutes())}:${p(now.getSeconds())}`
    },

    showSuccessMessage(message) {
      this.successMessage = message
      this.showSuccess    = true
      setTimeout(() => { this.showSuccess = false }, 3000)
    },

    showErrorMessage(message) {
      this.errorMessage = message
      this.showError    = true
      setTimeout(() => { this.showError = false }, 3000)
    },
  },
}
</script>

<style lang="less" scoped>
/* Reset and Base */
.start-page {
  position: relative;
  background-color: #1f1c1f;
  min-height: 100vh;
  box-sizing: border-box;
  overscroll-behavior: none; /* 禁止下拉刷新回弹，但允许正常滚动 */
}

#tipping {
  background: url('/img/login/bg.png') no-repeat top center;
  background-size: 100% auto;
  /* 内容从顶部约0.8cm处开始排版；底部预留全局导航栏(110px)+安全区高度，避免内容被遮挡 */
  padding: 25px 0 calc(140px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  min-height: 100vh;
}

/* User Info Section */
.userinfo {
  padding: 0 40px;
}

.hi {
  color: #fff;
  font-size: 48px;
  font-weight: 700;
}

.row {
  display: flex;
}

.row-sb {
  justify-content: space-between;
}

.column-c {
  align-items: center;
}

/* 资金概览卡片 */
.stats-card {
  display: flex;
  align-items: stretch;
  margin-top: 20px;
  padding: 26px 0;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(230, 185, 138, 0.18);
  border-radius: 20px;
  backdrop-filter: blur(6px);
}

.commission-item {
  flex: 1;
  min-width: 0;
  padding: 0 36px;
}

.stats-divider {
  width: 2px;
  margin: 6px 0;
  background: rgba(230, 185, 138, 0.22);
}

.com-title {
  font-size: 24px;
  font-weight: 700;
  color: #ffcd9c;
}

.money {
  margin-top: 8px;
  color: #fff;
  font-weight: 700;
  font-size: 32px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.menu-order {
  width: 48%;
  margin-top: 20px;
  position: relative;
  cursor: pointer;
  transition: transform 0.2s;
  
  &:active {
    transform: scale(0.98);
  }
}

.menu-order_img {
  display: block;
  width: 100%;
  border-radius: 16px;
}

.info {
  position: absolute;
  left: 109.2px;
  right: 8px;
  top: 0;
  bottom: 0;
  display: flex;
  font-size: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  font-weight: 700;
  color: #000;
}

.info-title {
  line-height: 1.3;
}

/* 开始抢购标题+进度数字整体居中，进度行对齐标题正中间 */
.grab-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.order-progress {
  margin-top: 4px;
  font-size: 24px;
  font-weight: 500;
  color: #6b543a;
  letter-spacing: 1px;
  white-space: nowrap;
  line-height: 1.2;
}

.order-limit-text {
  margin-top: 2px;
  font-weight: normal;
  font-size: 22px;
  color: #333;
}

/* Main Body Section */
.main-body {
  padding: 0 40px;
}

.vip-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  padding: 0 31.2px 0 124.8px;
  margin-top: 28px;
  height: 107.4px;
  background: url('/img/vipbei.png') no-repeat center / 100% 100%;
  border: none;
  border-radius: 16px;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
  
  &:active {
    opacity: 0.8;
  }
}

.vip-info::before {
  content: '';
  position: absolute;
  left: 30px;
  top: 50%;
  transform: translateY(-50%);
  width: 60px;
  height: 60px;
  background: url('') no-repeat center / contain;
}

/* 左侧 VIP 标签：与页面其它文字(26px)保持一致 */
.vip-info > span {
  font-size: 26px;
  font-weight: 700;
}

.vip-right span {
  color: #f3c7a2;
  margin-right: 10px;
  font-size: 26px;
}

.vip-right img {
  width: 78px;
  margin-left: 10px;
}

.menu-list {
  background: #fff;
  margin-top: 28px;
  padding: 0 23.4px;
  border-radius: 23.4px;
}

.menu-item {
  height: 109.2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0ede8;
  cursor: pointer;
  
  &:active {
    background: #f9f9f9;
  }
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-item img {
  width: 78px;
  margin-right: 31.2px;
}

.menu-item span {
  color: #000;
  font-size: 26px;
  font-weight: 500;
}

::v-deep .van-icon-arrow {
  color: #655142;
}

/* Modals and Toasts */
.message-toast {
  position: fixed;
  top: 120px;
  right: 20px;
  padding: 20px 24px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 28px;
  font-weight: 500;
  z-index: 2000;
  animation: slideInRight 0.3s ease-out;
  box-shadow: 0 8px 25px rgba(0,0,0,0.3);
  max-width: 80vw;

  .toast-icon { font-size: 28px; flex-shrink: 0; }
  span { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
}

.success-toast { background: #10b981; color: #fff; border: 1px solid #059669; }
.error-toast   { background: #ef4444; color: #fff; border: 1px solid #dc2626; }

@keyframes slideInRight {
  from { transform: translateX(100%); opacity: 0; }
  to   { transform: translateX(0);    opacity: 1; }
}

/* 打针订单充值提示条 */
.dazhen-recharge-notice {
  text-align: left;
  color: #b91c1c;
  font-size: 24px;
  font-weight: 600;
  padding: 16px;
  margin-bottom: 16px;
  background: rgba(239, 68, 68, 0.10);
  border: 1px solid #ef4444;
  border-radius: 8px;
  line-height: 1.5;
}

/* 打针弹窗充值金额行：紧跟幸运订单提示下方，单行显示，同色同样式 */
.dazhen-recharge-amount {
  margin-top: 10px;
}

/* 去充值按钮：打针弹窗中间按钮，橙红渐变 */
.recharge-btn {
  background: linear-gradient(to right, #f97316, #ef4444);
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 16px 10px;
  font-size: 24px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s;

  &:hover { filter: brightness(1.1); transform: translateY(-2px); }
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: #212121;
  border-radius: 20px;
  /* 弹窗整体占手机屏幕约四分之三：宽75vw、最高75vh，超出内部滚动，不顶满屏幕；
     max-width 用 rem（postcss 不转换）作桌面端上限，避免被转成 vw 后压缩手机宽度 */
  width: 75vw;
  max-width: 32.5rem;
  max-height: 75vh;
  display: flex;
  flex-direction: column;
  border: 1px solid #766350;
  box-shadow: 0 10px 40px rgba(0,0,0,0.5);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px;
  border-bottom: 1px solid #333;

  h3 {
    margin: 0;
    font-size: 28px;
    font-weight: 600;
    color: #e6b98a;
  }
}

.close-btn {
  background: #333;
  border: 1px solid #555;
  font-size: 28px;
  cursor: pointer;
  color: #999;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;

  &:hover { background: #444; color: #fff; }
}

.modal-body {
  padding: 20px 28px;
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
}

.modal-footer {
  padding: 20px 28px;
  border-top: 1px solid #333;
  display: flex;
  gap: 12px;
  justify-content: space-between;

  /* 按钮等宽自适应：打针弹窗三按钮并排时不溢出 */
  button {
    flex: 1 1 0;
    min-width: 0;
  }
}

.order-info { display: flex; flex-direction: column; gap: 16px; }

.order-time, .order-number {
  display: flex;
  align-items: center;
  gap: 12px;
}

.time-label, .number-label {
  font-size: 22px;
  color: #999;
  font-weight: 500;
  white-space: nowrap;
}

.time-value, .number-value {
  font-size: 24px;
  color: #e6b98a;
  font-weight: 600;
  font-family: 'Courier New', monospace;
}

.goods-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: #2a2a2a;
  border-radius: 12px;
  border: 1px solid #444;
}

.goods-image-section {
  flex: 0 0 88px;
  .goods-image {
    width: 88px;
    height: 88px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #555;
  }
}

.goods-info-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .goods-name  { font-size: 24px; color: #fff; font-weight: 600; line-height: 1.4; }
  .goods-brand { font-size: 22px; color: #999; }
}

.amount-summary {
  padding: 16px;
  background: #2a2a2a;
  border-radius: 12px;
  border: 1px solid #444;
}

.amount-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  & + .amount-row { margin-top: 16px; }

  .amount-label    { font-size: 24px; color: #999;    font-weight: 500; white-space: nowrap; }
  .amount-value    { font-size: 28px; color: #fff;    font-weight: 700; text-align: right; word-break: break-all; }
  .commission-value{ font-size: 28px; color: #f97316; font-weight: 700; text-align: right; word-break: break-all; }
}

.place-order-btn {
  background: linear-gradient(to right, #efcba7, #dcab76);
  color: #68302c;
  border: none;
  border-radius: 12px;
  padding: 16px 10px;
  font-size: 24px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s;

  &:hover:not(:disabled) { filter: brightness(1.1); transform: translateY(-2px); }
  &:disabled { background: #444; color: #666; cursor: not-allowed; }
}

.refresh-btn {
  background: #3b82f6;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 20px 36px;
  font-size: 28px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;

  &:hover { background: #2563eb; transform: translateY(-2px); }
}

.cancel-btn {
  background: #2a2a2a;
  color: #999;
  border: 1px solid #444;
  border-radius: 12px;
  padding: 16px 10px;
  font-size: 24px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;

  &:hover { background: #333; color: #ccc; }
}

.loading-order {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #e6b98a;
  background: rgba(230, 185, 138, 0.08);
  border: 1px solid #766350;
  border-radius: 16px;
  margin: 20px 0;
  font-size: 28px;
}

.loading-icon {
  font-size: 36px;
  margin-right: 16px;
  animation: spin 1s linear infinite;
}

.no-order {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #ef4444;
  background: rgba(239, 68, 68, 0.08);
  border: 1px solid #dc2626;
  border-radius: 16px;
  margin: 20px 0;
  font-size: 28px;
}

.no-order-icon { font-size: 48px; margin-bottom: 16px; }

@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
</style>
